export const LIST_HEADER = {
  KIND: { HEADING: "heading", SUBTITLE: "subtitle" },
} as const;